'use client'
import colors from "../styles/colors";
import Home from "../components/home/page";
// import colors from "./styles/colors";

export default function HomePage(){
  
  return(
    <div className="w-full min-h-screen" style={{backgroundColor:colors.background}}>
     <Home/>
    </div>
  )
}